import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useTranslation } from 'react-i18next';
import Editor from '../jobs/editor';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { updateEmailTemplate } from '../../../redux/actions/company_action';

const MainContainer = styled.main`
  padding: 0;
  .k-window-content,
  .k-prompt-container {
    padding: 0;
  }
  header {
    background-color: ${palette.blue};
    color: ${palette.white};
    font-size: 18px;
    height: 40px;
    display: flex;
    justify-items: center;
    align-items: center;
    padding-left: 20px;
    text-transform: uppercase;
  }
  .containerBody {
    width: 50vw;
    height: 40vh;
    article {
      display: grid;
      grid-template-columns: 30% 70%;
      height: calc(100% - 60px);
      .dataImport {
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        label,
        h3 {
          text-align: center;
        }
        h3 {
          font-size: 16px;
          text-transform: uppercase;
        }
      }
    }
  }
  .k-dialog-buttongroup {
    display: grid;
    grid-template-columns: 50% 50%;
    button {
      width: 50%;
      justify-self: center;
      height: 25px;
      cursor: pointer;
    }
    .cancel {
      background: none;
      border: none;
      font-weight: 400;
      color: ${palette.red};
    }
    .save {
      background: none;
      border: none;
      font-weight: 400;
      background-color: ${palette.blue};
      color: ${palette.white};
      border-radius: 10px;
    }
  }
  .EditorComment {
    height: calc(100% - 43px);
  }
`;

const ModalEditEmail = (props) => {
  const { toogleModal, selectEmailData } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation(['admin']);
  const [state, setState] = React.useState({
    body: '',
  });
  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      ...selectEmailData,
    }));
  }, []);
  const onChange = ({ target }) => {
    const { value, name } = target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const onSave = () => {
    toogleModal();
    dispatch(updateEmailTemplate(state));
  };
  return (
    <MainContainer>
      <Dialog>
        <section className="containerBody">
          <header> {t('EditEmailBody')} </header>
          <article>
            <div className="dataImport">
              <h3> {t('ImportantInfo')} </h3>
              <label> {`Empresa: {COMPANY}`} </label>
              <label> {`Vacante: {VACANCY}`} </label>
              <label> {`Candidato: {CANDIDATE}`} </label>
            </div>
            <div>
              <Editor upstream={state.body} sendData={(value) => onChange({ target: { name: 'body', value } })} />
            </div>
          </article>
        </section>
        <DialogActionsBar>
          <button type="button" onClick={toogleModal} className="cancel">
            {t('addCancelTest')}
          </button>
          <button type="button" className="save" onClick={onSave}>
            {t('Accept')}
          </button>
        </DialogActionsBar>
      </Dialog>
    </MainContainer>
  );
};

ModalEditEmail.propTypes = {
  toogleModal: PropTypes.func,
  selectEmailData: PropTypes.object,
};

ModalEditEmail.defaultProps = {
  toogleModal: () => {},
  selectEmailData: {},
};

export default ModalEditEmail;
